module.exports = __webpack_public_path__ + "media/DIGITAL.9391f1fe.mp3";